import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const ProjectCostCodeDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: costCodeOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'costCodeDescription',
    valueAttribute: 'costCode1',
    params: { windowId: 'projectCostCode' },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={costCodeOptions} columnNames={COLUMN_NAMES} />;
};
